

export const resolveYAxisMaxMinValues = (array, factor) => {
  // Spreading Note: we spread in the array values because this method of Math class doesnt take an array as its arg, needs to be a flat list of values
  const maxFieldValue = Math.max(...array);
  const minFieldValue = Math.min(...array);
  //console.log("[MAX / MIN OF NORMALIZED (SANITIZED) METRICS]:", maxFieldValue, minFieldValue)
  
  // Resolve Min and Max Values To An Round Number / Defined Increment: only allowed to be increments of 'factor' (5 is the arg inlined in the call site of this helper in the NEP technique - i.e. this enrichment helper is a single exposed function called from the assembly orchestrator, orchestrating NEP)
  const max = Math.ceil( (maxFieldValue * 1.1) / factor ) * factor // Add 10% padding
  const min = minFieldValue >= 0 ? 0 : Math.floor( (minFieldValue * 1.2) / factor ) * factor; // Add 20% padding if negative value in range of values  

  return { max, min }
}